import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// utils
import { isBillingHardLocked } from '../utils/billingLock';
// routes
import { PATH_DASHBOARD, PATH_PAGE } from '../routes/paths';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
};

/**
 * After billing grace expires, block the entire dashboard except Assinatura
 * (so admins can reactivate) and redirect everything else to /billing-locked.
 */
export default function BillingLockGuard({ children }: Props) {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const locked = isBillingHardLocked((user as any)?.subscription);
  if (!locked) return <>{children}</>;

  const allowed =
    pathname === PATH_DASHBOARD.organization.subscription ||
    pathname.startsWith(`${PATH_DASHBOARD.organization.subscription}/`);

  if (allowed) return <>{children}</>;

  return <Navigate to={PATH_PAGE.billingLocked} replace />;
}
